/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
// import { useLocation } from "react-router";
import SVG from "react-inlinesvg";
import {
  // FormattedMessage,
  injectIntl,
} from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { NavLink, useLocation, withRouter } from "react-router-dom";
import * as TYPE from "../../../../../app/lib/contrant";
import { checkIsActive, toAbsoluteUrl } from "../../../../_helpers";

function AsideMenuList(props) {
  const { listUserLoginPermission } = useSelector(
    (state) => ({
      listUserLoginPermission: state.authReducer.listUserLoginPermission,
    }),
    shallowEqual
  );
  console.log({listUserLoginPermission})
  let { layoutProps, intl } = props;
  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
      "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };

  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/* Dashboard management */}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_TRANG_CHU) && (
          <li
            className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/dashboard">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Home/Home.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.DASHBOARD" })}
              </span>
            </NavLink>
          </li>
        )}

        {/* Content management */}
        {/*begin::1 Level*/}

        {(listUserLoginPermission.includes(TYPE.QUAN_LY_HOMEPAGE) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_POPUP) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_BANNER) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_TRANG_DOI_TAC) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_CAU_HINH_MARKETING) ||
          listUserLoginPermission.includes(TYPE.LICH_SU_VOICEBOT)) && (
            <li className="menu-section ">
              <h4 className="menu-text">Marketing</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>
          )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_HOMEPAGE) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/homepage",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/homepage">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Git3.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.HOMEPAGE" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.HOMEPAGE" })}
                    </span>
                  </span>
                </li>
                {listUserLoginPermission.includes(TYPE.QUAN_LY_BANNER) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/banner-homepage"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/banner-homepage">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.SCREEN_BANNER" })}
                      </span>
                    </NavLink>
                  </li>
                )}

              {/*   {listUserLoginPermission.includes(TYPE.QUAN_LY_CHI_NHANH) && (
                  <li
                    className={`menu-item ${getMenuItemActive("/shop/list")}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/shop/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.SHOP.MANAGEMENT" })}
                      </span>
                    </NavLink>
                  </li>
                )} */}
               {/*  <li
                  className={`menu-item ${getMenuItemActive(
                    "/video_post/video-homepage"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/video_post/video-homepage"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.VIDEO_MANANAGEMENT" })}
                    </span>
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </li>
        )}

       {/*  {listUserLoginPermission.includes(TYPE.QUAN_LY_TIN_TUC) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/content",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/content">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.CONTENT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.CONTENT" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/content/list")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/content/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.LIST_CONTENT" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/post_agency/list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/post_agency/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.LIST_POST_AGENCY" })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/content/tag/list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/content/tag/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">{intl.formatMessage({ id: 'SIDEBAR.LIST_TAG_CONTENT' })}</span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/content/category"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/content/category/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.LIST_POST_CATEGORY" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/video_post/list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/video_post/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.VIDEO_POST" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/author"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/author">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.AUTHOR" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/expert"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/expert">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.EXPERT" })}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_PAGE) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/shop",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/shop">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Difference.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.PAGE_SETTING" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.PAGE_SETTING" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/page_setting/list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/page_setting/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.OTHER_PAGE_SETTING" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/page_setting/home"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/page_setting/home">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.HOME_PAGE_SETTING" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/page_setting/franchise-partners"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/page_setting/franchise-partners"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.FRANCHISE_PARTNERS_PAGE_SETTING",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/page_setting/phoenix"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/page_setting/phoenix">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.PHOENIX_PAGE_SETTING",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/page_setting/collaborator"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/page_setting/collaborator"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.COLLABORATOR_PAGE_SETTING",
                      })}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
      {/*   {listUserLoginPermission.includes(TYPE.QUAN_LY_POPUP) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/popup",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/history">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Media/Airplay-video.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.POPUP" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.POPUP" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/popup/list")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/popup/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.POPUP" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/popup/show-popup"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/popup/show-popup">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.SETTING_SHOW_POPUP" })}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}
        {/*end::1 Level*/}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_NOTIFY) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/notify",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/notify">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/General/Notifications1.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.NOTIFY" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.NOTIFY" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/notify/config")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/notify/config">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.CONFIG_NOTIFY" })}
                    </span>
                  </NavLink>
                </li>


                <li
                  className={`menu-item ${getMenuItemActive("/notify/HNG")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/notify/HNG">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.CONFIG_NOTIFY_HNG" })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/notify/onesignal"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/notify/onesignal">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.SEND_NOTIFY_ONESIGNAL",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/notify/history"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/notify/history">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.HISTORY_NOTIFY" })}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_BANNER) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/screen-banner",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/screen-banner">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Home/Curtains.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.SCREEN_BANNER" })}
              </span>
            </NavLink>
          </li>
        )}
      {/*   {listUserLoginPermission.includes(TYPE.QUAN_LY_TRANG_DOI_TAC) && (
          <li
            className={`menu-item ${getMenuItemActive("/partner/list", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/partner/list">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Home/Curtains.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.PARTNER" })}
              </span>
            </NavLink>
          </li>
        )} */}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_CAU_HINH_MARKETING) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/campaign-config",
              true
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/campaign-config">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Tools/Pantone.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.MARKETING_CONFIG" })}
              </span>
            </NavLink>
          </li>
        )} */}

       {/*  {listUserLoginPermission.includes(TYPE.LICH_SU_VOICEBOT) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/voice-bot",
              true
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/voice-bot">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Home/Curtains.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.VOICE_HISTORY" })}
              </span>
            </NavLink>
          </li>
        )} */}

        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_LI_XI) && ( */}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_CHUONG_TRINH_LIXI) && <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/lucky-management",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/lucky-management">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/General/Notifications1.svg"
                )}
              />
            </span>
            <span className="menu-text">
              {intl.formatMessage({ id: "SIDEBAR.LUCKY_MONEY" })}
            </span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">
                    {intl.formatMessage({ id: "SIDEBAR.LUCKY_MONEY" })}
                  </span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/lucky-management/configure-program"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/lucky-management/configure-program">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">
                    {'Cấu hình chương trình'}
                  </span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>} */}
        {/* )} */}

        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.THUONG_NGUOI_DUNG)) && (
            <li className="menu-section ">
              <h4 className="menu-text">Chăm sóc khách hàng</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>
          )}

        {listUserLoginPermission.includes(TYPE.THUONG_NGUOI_DUNG) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/commission_cms",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/commission_cms">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.USER.COMMISSION_CMS" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.USER.COMMISSION_CMS",
                      })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/commission_cms/create"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/commission_cms/create">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.COMMISSION_CMS" })}
                    </span>
                  </NavLink>
                </li>

                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/commission_cms/get-list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/commission_cms/get-list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.LIST.COMMISSION_CMS",
                      })}
                    </span>
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </li>
        )}
        {listUserLoginPermission.includes(TYPE.THUONG_NGUOI_DUNG) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/event",
              false
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/event">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
              </span>
              <span className="menu-text">
                Sự kiện
              </span>
            </NavLink>
          </li>
        )}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_NGUOI_DUNG) ||
          listUserLoginPermission.includes(TYPE.QUAN_TRI_NGUOI_DUNG)) && (
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/user",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/user">
                <span className="svg-icon menu-icon">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/General/User.svg")} />
                </span>
                <span className="menu-text">
                  {intl.formatMessage({ id: "SIDEBAR.USER" })}
                </span>
              </NavLink>
              <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li className="menu-item menu-item-parent" aria-haspopup="true">
                    <span className="menu-link">
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.USER" })}
                      </span>
                    </span>
                  </li>
                  {/*begin::2 Level*/}
                  {// listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
                    (listUserLoginPermission.includes(
                      TYPE.XEM_DANH_SACH_NGUOI_DUNG
                    ) ||
                      listUserLoginPermission.includes(
                        TYPE.QUAN_TRI_NGUOI_DUNG
                      )) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/list-user"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/user/list-user">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({ id: "SIDEBAR.USER" })}
                          </span>
                        </NavLink>
                      </li>
                    )}
                  {/*end::2 Level*/}
                  {/*begin::2 Level*/}
                  {// listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
                    (listUserLoginPermission.includes(TYPE.DANH_SACH_YEU_CAU_KYC) ||
                      listUserLoginPermission.includes(
                        TYPE.QUAN_TRI_YEU_CAU_KYC
                      )) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/list-kyc"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/user/list-kyc">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({ id: "SIDEBAR.LIST_KYC" })}
                          </span>
                        </NavLink>
                      </li>
                    )}
                  {/*end::2 Level*/}
                 {/*  {// listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
                    (listUserLoginPermission.includes(
                      TYPE.DANH_SACH_YEU_CAU_NANG_CAP
                    ) ||
                      listUserLoginPermission.includes(
                        TYPE.QUAN_TRI_YEU_CAU_NANG_CAP_VIP
                      )) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/list-request-upgrade-user"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/user/list-request-upgrade-user"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.REQUEST_UPGRADE.LIST",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )} */}

                  {// listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
                    listUserLoginPermission.includes(
                      TYPE.DANH_SACH_NGUOI_DA_GIOI_THIEU
                    ) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/referral"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/user/referral">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.USER_ACTIVITY_REF",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )}

                  {listUserLoginPermission.includes(
                    TYPE.DANH_SACH_LOI_LO_NGUOI_DUNG
                  ) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/list-pnl"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/user/list-pnl">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {"Danh sách lời lỗ người dùng"}
                          </span>
                        </NavLink>
                      </li>
                    )}
                  {/* {listUserLoginPermission.includes(
                    TYPE.DANH_SACH_MOC_GIOI_THIEU
                  ) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/introductoryLandmark"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/user/introductoryLandmark"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.MILESTONE.REFERRAL",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )} */}
                  {/* {listUserLoginPermission.includes(
                    TYPE.QUAN_LY_THUONG_THEO_MOC_GIOI_THIEU
                  ) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/milestone"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/user/milestone">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.USER_MILESTONE_REFERRAL",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )} */}
                  {listUserLoginPermission.includes(TYPE.HOA_HONG_NGUOI_DUNG) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/user/commission"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/user/commission">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.USER_COIN_COMMISSION",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
                    listUserLoginPermission.includes(TYPE.XEM_KHOA_RUT_TIEN)) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/list-lock-withdraw"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/user/list-lock-withdraw"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.LIST_LOCK_WITHDRAW",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )}
                    {(listUserLoginPermission.includes(TYPE.QUAN_LY_NGUOI_DUNG) ||
                    listUserLoginPermission.includes(TYPE.XEM_KHOA_RUT_TIEN)) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/user/top-runner"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/user/top-runner"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            Top người chạy
                          </span>
                        </NavLink>
                      </li>
                    )}
                </ul>
              </div>
            </li>
          )}

        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_DOI_SOAT_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) ||
          listUserLoginPermission.includes(TYPE.XEM_NAP_TIEN) ||
          listUserLoginPermission.includes(TYPE.DANH_SACH_DON_HANG) ||
          listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_DAI_SU)) && (
            <li className="menu-section ">
              <h4 className="menu-text">Kinh doanh</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>
          )}

        {/*begin::1 Level*/}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.XEM_NAP_TIEN)) && (
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/transaction",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/transaction">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Home/Commode2.svg")}
                  />
                </span>
                <span className="menu-text">
                  {intl.formatMessage({ id: "SIDEBAR.TRANSACTION" })}
                </span>
              </NavLink>
              <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li className="menu-item menu-item-parent" aria-haspopup="true">
                    <span className="menu-link">
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.TRANSACTION" })}
                      </span>
                    </span>
                  </li>
                  {/*begin::2 Level*/}
                  {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
                    listUserLoginPermission.includes(TYPE.XEM_NAP_TIEN)) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/transaction/money/list"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/transaction/money/list">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.TRANSACTION.LIST_MONEY",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )}
                  {/**------------Ruts tien --------------- */}
                  {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/withdraw-money/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/withdraw-money/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.TRANSACTION.LIST_WITHDRAW_MONEY",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/**------------Quy đổi --------------- */}
                    {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
                    listUserLoginPermission.includes(TYPE.XEM_MUA_VANG)) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/transaction/buy-gold/list"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/transaction/buy-gold/list"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({
                              id: "SIDEBAR.TRANSACTION.LIST_BUY_GOLD",
                            })}
                          </span>
                        </NavLink>
                      </li>
                    )}

                  {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/deposit-usdt/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/deposit-usdt/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.LIST_DEPOSIT_USDT",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/withdraw-usdt/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/withdraw-usdt/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.LIST_WITHDRAW_USDT",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {/*begin::2 Level*/}
                

                  {/*begin::2 Level*/}
                  {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/sell-gold/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/sell-gold/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.TRANSACTION.LIST_SELL_GOLD",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}

                  {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/gold_t/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/gold_t/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.TRANSACTION.LIST_GOLD",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/* {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
                    listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_HNG)) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/transaction/list-swap-buy-hng"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/transaction/list-swap-buy-hng"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({ id: "SIDEBAR.LIST_SWAP_BUY_HNG" })}
                          </span>
                        </NavLink>
                      </li>
                    )} */}
                  {/* {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) ||
                    listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_HNG)) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/transaction/list-swap-hng"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/transaction/list-swap-hng"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({ id: "SIDEBAR.LIST_SWAP_HNG" })}
                          </span>
                        </NavLink>
                      </li>
                    )} */}
                  {/* {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) || listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_USD)) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/list-buy-usdt"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/list-buy-usdt"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.LIST_BUY_USDT" })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                 {/*  {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) || listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_USD)) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/list-sell-usdt"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/list-sell-usdt"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.LIST_SELL_USDT" })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/* {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) || listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/list-buy-xau"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/list-buy-xau"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.LIST_BUY_XAU" })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/* {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) || listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/list-sell-xau"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/list-sell-xau"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.LIST_SELL_XAU" })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/* {(listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) || listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/list-swap-ton"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/list-swap-ton"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.LIST_SWAP_TON" })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/withdraw-prize/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/withdraw-prize/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.TRANSACTION.LIST_WITHDRAW_PRIZE",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/staking-daily"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/staking-daily"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.STAKING_DAILY" })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                  {/*begin::2 Level //Danh sách rút vàng*/}
                 {/*  {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/gold/tranfer/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/gold/tranfer/list"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.TRANSACTION.LIST_TRANFER_GOLD",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}
 */}                  {/*end::2 Level*/}

                  {/*begin::2 Level //Danh sách rút vàng*/}
                  {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/transaction/send-gold-list-user"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/transaction/send-gold-list-user"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.SEND_GOLD_TO_LIST_USER",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )} */}
                </ul>
              </div>
            </li>
          )}
        {/*end::1 Level*/}

   {/*      {listUserLoginPermission.includes(TYPE.QUAN_LY_DOI_SOAT_GIAO_DICH) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/verify",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/verify">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.VERIFY" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                {listUserLoginPermission.includes(TYPE.QUAN_LY_GIAO_DICH) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/verify/verify-transaction"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/verify/verify-transaction"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({
                          id: "SIDEBAR.VERIFY_TRANSACTION",
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}

              </ul>
            </div>
          </li>
        )}
 */}
        {/*end::1 Level*/}
    {/*     {(listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG) ||
          listUserLoginPermission.includes(TYPE.DANH_SACH_DON_HANG)) && (
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/order",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/order">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}
                  />
                </span>
                <span className="menu-text">
                  {intl.formatMessage({ id: "SIDEBAR.ORDER" })}
                </span>
              </NavLink>
              <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li className="menu-item menu-item-parent" aria-haspopup="true">
                    <span className="menu-link">
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.ORDER_LIST" })}
                      </span>
                    </span>
                  </li>
                  {(listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG) ||
                    listUserLoginPermission.includes(
                      TYPE.DANH_SACH_DON_HANG
                    )) && (
                      <li
                        className={`menu-item ${getMenuItemActive("/order/list")}`}
                        aria-haspopup="true"
                      >
                        <NavLink className="menu-link" to="/order/list">
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({ id: "SIDEBAR.ORDER_LIST" })}
                          </span>
                        </NavLink>
                      </li>
                    )}
                  {listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/order/voucher"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/order/voucher">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({ id: "SIDEBAR.ORDER_VOUCHER" })}
                        </span>
                      </NavLink>
                    </li>
                  )}
                  {listUserLoginPermission.includes(TYPE.QUAN_LY_DON_HANG) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/order/user_voucher"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/order/user_voucher">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.ORDER_USER_VOUCHER",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </div>
            </li>
          )} */}
        {/*end::1 Level*/}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_DOANH_NGHIEP) && <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/merchant_hng",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/merchant_hng">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl("/media/svg/icons/Communication/Group.svg")}
              />
            </span>
            <span className="menu-text">
              {intl.formatMessage({ id: "SIDEBAR.MERCHANT_HNG" })}
            </span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">
                    {intl.formatMessage({ id: "SIDEBAR.MERCHANT_HNG.LIST" })}
                  </span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive("/merchant_hng/list")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/merchant_hng/list">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">
                    {intl.formatMessage({ id: "SIDEBAR.MERCHANT_HNG.LIST" })}
                  </span>
                </NavLink>
              </li>
              {/* <li
                className={`menu-item ${getMenuItemActive("/merchant_hng/config")}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/merchant_hng/config">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">
                    {intl.formatMessage({ id: "SIDEBAR.CONFIG" })}
                  </span>
                </NavLink>
              </li> */}
              {/* <li
                className={`menu-item ${getMenuItemActive(
                  "/merchant_hng/request"
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/merchant_hng/request">
                  <i className="menu-bullet menu-bullet-dot">
                    <span />
                  </i>
                  <span className="menu-text">
                    {intl.formatMessage({ id: "SIDEBAR.MERCHANT_HNG.REQUEST" })}
                  </span>
                </NavLink>
              </li> */}
            </ul>
          </div>
        </li>}

        {(listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) || listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_DAI_SU)) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/agency",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/agency">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.AGENCY" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.AGENCY_LIST" })}
                    </span>
                  </span>
                </li>
                {/*begin::2 Level*/}
                {(listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) || listUserLoginPermission.includes(TYPE.XEM_DANH_SACH_DAI_SU)) && (
                  <li
                    className={`menu-item ${getMenuItemActive("/agency/list")}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/agency/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.AGENCY_LIST" })}
                      </span>
                    </NavLink>
                  </li>
                )}

                {listUserLoginPermission.includes(TYPE.QUAN_LY_AGENCY) && (
                  <>
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/agency/list-revenue"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/agency/list-revenue">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {"Quản lý doanh thu đại sứ"}
                        </span>
                      </NavLink>
                    </li>
                    {/*end::2 Level*/}

                    {/*begin::2 Level*/}
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/agency/config_list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/agency/config_list">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.CONFIG_AGENCY_LIST",
                          })}
                        </span>
                      </NavLink>
                    </li>
                    {/*end::2 Level*/}

                    {/*begin::2 Level*/}
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/agency/request/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/agency/request/list">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.AGENCY_REQUEST_LIST",
                          })}
                        </span>
                      </NavLink>
                    </li>
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/agency/request/level/listLevelOne"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink
                        className="menu-link"
                        to="/agency/request/level/listLevelOne"
                      >
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.AGENCY_REQUEST_LIST_LEVEL_ONE",
                          })}
                        </span>
                      </NavLink>
                    </li>
                    {/*end::2 Level*/}

                    {/*begin::2 Level*/}
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/agency/partners/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/agency/partners/list">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.PARTNERS_REQUEST_LIST",
                          })}
                        </span>
                      </NavLink>
                    </li>

                    {/*end::2 Level*/}
                  </>
                )}
              </ul>
            </div>
          </li>
        )}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/product",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/product">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.PRODUCT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.PRODUCT" })}
                    </span>
                  </span>
                </li>
                {/*begin::2 Level*/}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/product/category/list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/product/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({
                          id: "SIDEBAR.PRODUCT.LIST_PRODUCT",
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/product/category/list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/product/category/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({
                          id: "SIDEBAR.PRODUCT.LIST_CATEGORY",
                        })}
                      </span>
                    </NavLink>
                  </li>
                )} */}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/product/property/list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/product/property/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({
                          id: "SIDEBAR.PRODUCT.LIST_PROPERTY",
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/product/specifications/list"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link"
                      to="/product/specifications/list"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({
                          id: "SIDEBAR.PRODUCT.LIST_SPECIFICATIONS",
                        })}
                      </span>
                    </NavLink>
                  </li>
                )}
               {/*  
                {listUserLoginPermission.includes(TYPE.QUAN_LY_SAN_PHAM) && (
                  <li
                    className={`menu-item menu-item-submenu ${getMenuItemActive(
                      "/product/image_product/list",
                      true
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink
                      className="menu-link "
                      to="/product/image_product/list"
                    >
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.IMAGE_PRODUCT" })}
                      </span>
                    </NavLink>
                    <div className="menu-submenu">
                      <i className="menu-arrow" />
                      <ul className="menu-subnav">
                        <li
                          className="menu-item menu-item-parent"
                          aria-haspopup="true"
                        >
                          <span className="menu-link">
                            <span className="menu-text">
                              {intl.formatMessage({
                                id: "SIDEBAR.IMAGE_PRODUCT",
                              })}
                            </span>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </li>
                )} */}

                {/*end::2 Level*/}
              </ul>
            </div>
          </li>
        )}

        {/* PRIORITY */}
     {/*    {listUserLoginPermission.includes(TYPE.QUAN_LY_PRIORITY) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/priority",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/priority">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.PRIORITY.MANAGE" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.PRIORITY" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/priority/config"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/priority/config">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.PRIORITY.CONFIG",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/priority/benefit/config"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/priority/benefit/config">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.PRIORITY.BENEFIT.CONFIG",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/priority/upgrade/list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/priority/upgrade/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.PRIORITY.REQUEST.LIST",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/priority/user/list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/priority/user/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.PRIORITY.USER.LIST",
                      })}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}
        {/*end::1 Level*/}

        {(listUserLoginPermission.includes(TYPE.QUAN_LY_DS_MASTER) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_YC_VIP) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_VANG) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_TAI_KHOAN) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_DS_GIAO_DICH) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_TIEN_VANG_KHOA) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_CHO_VAY) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_DAU_TU) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_CUNG_HOP_TAC) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_DONG_TIEN) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_NFC)) && (
            <li className="menu-section ">
              <h4 className="menu-text">Kế toán tài chính</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>
          )}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_DS_MASTER) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/system-account",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/system-account">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Shield-user.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.MASTER_LIST" })}
              </span>
            </NavLink>
          </li>
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_YC_VIP) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/upgrade/list-success-upgrade",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/upgrade/list-success-upgrade">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Shield-user.svg"
                  )}
                />
              </span>
              <span className="menu-text">{"Quản lý nâng cấp thành công"}</span>
            </NavLink>
          </li>
        )}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_VANG) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/assets-management",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/assets-management">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Patch.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.ASSET" })}
              </span>
            </NavLink>
          </li>
        )}
        {/* QUAN_LY_EVOUCHER_DOANH_NGHIEP */}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_EVOUCHER_DOANH_NGHIEP) && <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/voucher",
            true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to="/voucher">
            <span className="svg-icon menu-icon">
              <SVG
                src={toAbsoluteUrl(
                  "/media/svg/icons/General/Notifications1.svg"
                )}
              />
            </span>
            <span className="menu-text">
              {"Quản lý E-Voucher"}
            </span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">
                    {"Quản lý E-Voucher"}
                  </span>
                </span>
              </li>
              {/* <li
                className={`menu-item ${getMenuItemActive(
                  "/voucher/business-voucher",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/voucher/business-voucher">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Patch.svg")} />
                  </span>
                  <span className="menu-text">{"Evoucher doanh nghiệp"}</span>
                </NavLink>
              </li> */}
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">
                    {"Quản lý Thiệp E-Voucher"}
                  </span>
                </span>
              </li>
              <li
                className={`menu-item ${getMenuItemActive(
                  "/voucher/evoucher-config",
                  false
                )}`}
                aria-haspopup="true"
              >
                <NavLink className="menu-link" to="/voucher/evoucher-config">
                  <span className="svg-icon menu-icon">
                    <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Patch.svg")} />
                  </span>
                  <span className="menu-text">{"Quản lý thiệp Evoucher"}</span>
                </NavLink>
              </li>
            </ul>
          </div>
        </li>}
        
        {/* QUAN_LY_EVOUCHER_DOANH_NGHIEP */}


        {listUserLoginPermission.includes(TYPE.QUAN_LY_TAI_KHOAN) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/master/history",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/master">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.ACCOUNT_MANAGEMENT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.MASTER_LIST" })}
                    </span>
                  </span>
                </li>

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/cash_flow",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/master/history/cash_flow">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.CASH_FLOW" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/commission",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/master/history/commission"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.COMMISSION" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/interest",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/master/history/interest">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.INTEREST" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/marketing",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/master/history/marketing">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.MARKETING" })}
                    </span>
                  </NavLink>
                </li> */}
                {/*end::2 Level*/}
                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/marketing_event",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/master/history/marketing_event"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.MARKETING_EVENT" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/deposit_withdrawal",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/master/history/deposit_withdrawal"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.DEPOSIT_WITHDRAWAL" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/REWARD_POOL",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/master/history/reward_pool"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.REWARD_POOL" })}
                    </span>
                  </NavLink>
                </li> */}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/invest",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/master/history/invest">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.INVEST" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}

                {/*begin::2 Level*/}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/upgrade",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/master/history/upgrade">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.UPGRADE" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/sell_product",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink
                    className="menu-link"
                    to="/master/history/sell_product"
                  >
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.SELL_PRODUCT" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/master/history/evoucher",
                    1
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/master/history/evoucher">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.EVOUCHER" })}
                    </span>
                  </NavLink>
                </li>
                {/*end::2 Level*/}
              </ul>
            </div>
          </li>
        )}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_DS_GIAO_DICH) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/system-change-balance",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/system-change-balance">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/MC.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.HISTORY_CHANGE_COIN" })}
              </span>
            </NavLink>
          </li>
        )}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_TIEN_VANG_KHOA) && (
          <li
            className={`menu-item ${getMenuItemActive(
              "/list-coin-lock",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/list-coin-lock">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Code/Lock-circle.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.USER_COIN_LOCK" })}
              </span>
            </NavLink>
          </li>
        )}

        {/* begin::1 Level*/}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_CHO_VAY) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/loan",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/loan">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Stamp.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.LOAN" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.LOAN" })}
                    </span>
                  </span>
                </li>
                begin::2 Level
                <li
                  className={`menu-item ${getMenuItemActive("/loan/list")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/loan/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.CONFIG_LOAN" })}
                    </span>
                  </NavLink>
                </li>
                end::2 Level
                begin::2 Level
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/loan/user_list"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/loan/user_list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.USER_LOAN" })}
                    </span>
                  </NavLink>
                </li>
                end::2 Level
              </ul>
            </div>
          </li>
        )} */}
        {/*end::1 Level */}

        {/*begin::1 Level*/}
        {(listUserLoginPermission.includes(TYPE.QUAN_LY_DAU_TU) ||
          listUserLoginPermission.includes(TYPE.GIAO_DICH_CUNG_HOP_TAC)) && (
            <li
              className={`menu-item menu-item-submenu ${getMenuItemActive(
                "/accumulation",
                true
              )}`}
              aria-haspopup="true"
              data-menu-toggle="hover"
            >
              <NavLink className="menu-link menu-toggle" to="/accumulation">
                <span className="svg-icon menu-icon">
                  <SVG
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Communication/Incoming-box.svg"
                    )}
                  />
                </span>
                <span className="menu-text">
                  {intl.formatMessage({
                    id: "SIDEBAR.ACCUMULATION_PACKAGE.LIST",
                  })}
                </span>
              </NavLink>
              <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                  <li className="menu-item menu-item-parent" aria-haspopup="true">
                    <span className="menu-link">
                      <span className="menu-text">
                        {intl.formatMessage({
                          id: "SIDEBAR.ACCUMULATION_PACKAGE.LIST",
                        })}
                      </span>
                    </span>
                  </li>
                  {/*begin::2 Level*/}
                  {listUserLoginPermission.includes(TYPE.QUAN_TRI_DAU_TU) && (
                    <li
                      className={`menu-item ${getMenuItemActive(
                        "/accumulation/list"
                      )}`}
                      aria-haspopup="true"
                    >
                      <NavLink className="menu-link" to="/accumulation/list">
                        <i className="menu-bullet menu-bullet-dot">
                          <span />
                        </i>
                        <span className="menu-text">
                          {intl.formatMessage({
                            id: "SIDEBAR.ACCUMULATION_PACKAGE.LIST",
                          })}
                        </span>
                      </NavLink>
                    </li>
                  )}

                  {(listUserLoginPermission.includes(TYPE.QUAN_LY_DAU_TU) ||
                    listUserLoginPermission.includes(
                      TYPE.GIAO_DICH_CUNG_HOP_TAC
                    )) && (
                      <li
                        className={`menu-item ${getMenuItemActive(
                          "/accumulation/invest/list"
                        )}`}
                        aria-haspopup="true"
                      >
                        <NavLink
                          className="menu-link"
                          to="/accumulation/invest/list"
                        >
                          <i className="menu-bullet menu-bullet-dot">
                            <span />
                          </i>
                          <span className="menu-text">
                            {intl.formatMessage({ id: "SIDEBAR.INVEST.LIST" })}
                          </span>
                        </NavLink>
                      </li>
                    )}
                  {/*end::2 Level*/}
                </ul>
              </div>
            </li>
          )}

        {/*begin::1 Level*/}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_DONG_TIEN) && (
          <li
            className={`menu-item ${getMenuItemActive("/money-manage", false)}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/money-manage">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Shield-user.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.MONEY_MANAGEMENT" })}
              </span>
            </NavLink>
          </li>
        )}

       {/*  {listUserLoginPermission.includes(TYPE.QUAN_LY_NFC) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/nfc",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/nfc">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.NFC_MANAGEMENT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.NFC_LIST" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/nfc/list")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/nfc/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.NFC_LIST" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/nfc/list-report"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/nfc/list-report">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">{"Danh sách báo mất"}</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}

        {(listUserLoginPermission.includes(TYPE.QUAN_LY_CAU_HINH) ||
          listUserLoginPermission.includes(TYPE.SYSTEM_MANAGEMENT) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_MASTER) ||
          listUserLoginPermission.includes(TYPE.THUONG_KYC_DAI_LY) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_NGAN_HANG) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_THONG_KE) ||
          listUserLoginPermission.includes(TYPE.QUAN_LY_MERCHANT)) && (
            <li className="menu-section ">
              <h4 className="menu-text">Quản trị</h4>
              <i className="menu-icon flaticon-more-v2"></i>
            </li>
          )}
        {/*begin::1 Level*/}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_CAU_HINH) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/system-config",
              true
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link menu-toggle " to="/system-config">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/Settings-2.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.CONFIG" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/system-config/general"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/system-config/general">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">{"Cấu hình chung"}</span>
                  </NavLink>
                </li>
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/system-config/gold"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/system-config/gold">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">{"Cấu hình vàng"}</span>
                  </NavLink>
                </li> */}
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/system-config/hng"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/system-config/hng">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">{"Cấu hình RISE"}</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) && <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            "/gold/list",
            true
          )}`}
          aria-haspopup="true"

        >
          <NavLink className="menu-link " to="/gold/list">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Update.svg")} />
            </span>
            <span className="menu-text">{intl.formatMessage({ id: 'SIDEBAR.GOLD' })}</span>
          </NavLink>
          <div className="menu-submenu">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">{intl.formatMessage({ id: 'SIDEBAR.GOLD' })}</span>
                </span>
              </li>
            </ul>
          </div>
        </li>} */}

        {listUserLoginPermission.includes(TYPE.QUAN_LY_MASTER) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/root-account",
              true
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/root-account">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/General/Star.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.DASHBOARD.HISTORY_ROOT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.DASHBOARD.HISTORY_ROOT",
                      })}
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
        )}

        {listUserLoginPermission.includes(TYPE.THUONG_KYC_DAI_LY) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/agency-bonus",
              true
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link " to="/agency-bonus">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Gift.svg")}
                />
              </span>
              <span className="menu-text">Thưởng KYC Đại Sứ</span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">Thưởng KYC Đại Sứ</span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
        )}

        {/*begin::1 Level*/}
        {listUserLoginPermission.includes(TYPE.SYSTEM_MANAGEMENT) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/admin",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/admin">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Tools/Tools.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.ROLE_MANAGEMENT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.PERMISSION_LIST" })}
                    </span>
                  </span>
                </li>
                {/*begin::2 Level*/}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_ADMIN) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/admin/list-user"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/admin/list-user">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.ADMIN" })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}
                {/*begin::2 Level*/}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_VAI_TRO) && (
                  <li
                    className={`menu-item ${getMenuItemActive("/admin/role")}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/admin/role">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.ROLE_LIST" })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}
                {/*begin::2 Level*/}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_NHOM_QUYEN) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/admin/group-permission"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/admin/group-permission">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.GROUP_PERMISSION" })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}
                {/*begin::2 Level*/}
                {listUserLoginPermission.includes(TYPE.QUAN_LY_QUYEN) && (
                  <li
                    className={`menu-item ${getMenuItemActive(
                      "/admin/permission"
                    )}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/admin/permission">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.PERMISSION_LIST" })}
                      </span>
                    </NavLink>
                  </li>
                )}
                {/*end::2 Level*/}
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_NGAN_HANG) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/bank",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/bank">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Shopping/Credit-card.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.BANK_CONFIG" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.BANK_CONFIG" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive("/bank/list")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/bank/list">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.TRANSACTION.LIST_BANK",
                      })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive("/bank/config")}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/bank/config">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.TRANSACTION.LIST_BANK_CONFIG",
                      })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/bank/bank-by-user"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/bank/bank-by-user">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {"Quản lý liên kết ngân hàng người dùng"}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )}
        {/*end::1 Level*/}

       {/*  {listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/gold_price",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/gold_price">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.GOLD_PRICE" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.GROUP.GOLD_PRICE" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/gold_price/group"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/gold_price/group">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.GROUP.GOLD_PRICE" })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/gold_price/hana"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/gold_price/hana">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.HANA_GOLD_PRICE" })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/gold_price/reference"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/gold_price/reference">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.GOLD_PRICE.REFERENCE",
                      })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/gold_price/official"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/gold_price/official">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.GROUP.GOLD_PRICE.OFFICIAL",
                      })}
                    </span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </li>
        )} */}

        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_GIA_VANG) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/rate_mana",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/rate_mana">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/Design/Difference.svg")}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.RATE_MANANGEMENT" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.RATE_REFERENCE" })}
                    </span>
                  </span>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/rate_mana/reference"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/rate_mana/reference">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.RATE_REFERENCE" })}
                    </span>
                  </NavLink>
                </li>

                <li
                  className={`menu-item ${getMenuItemActive(
                    "/rate_mana/official"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/rate_mana/official">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.RATE_OFFICIAL",
                      })}
                    </span>
                  </NavLink>
                </li>

              </ul>
            </div>
          </li>
        )} */}
        {/* Accumulation management */}

        {/*end::1 Level*/}
        {listUserLoginPermission.includes(TYPE.QUAN_LY_THONG_KE) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/statistical",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/statistical">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Shopping/Chart-bar1.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.STATISTICAL" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.STATISTICAL" })}
                    </span>
                  </span>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/statistical/user"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/statistical/user">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {/* {intl.formatMessage({ id: "SIDEBAR.USER_THONGKE" })} */}
                      Báo cáo UrBox
                    </span>
                  </NavLink>
                </li>
                {/* <li
                  className={`menu-item ${getMenuItemActive(
                    "/statistical/commission"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/statistical/commission">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({
                        id: "SIDEBAR.USER_COIN_COMMISSION",
                      })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/statistical/purchase"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/statistical/purchase">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.NAP_RUT_THONGKE" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/statistical/assets"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/statistical/assets">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.ASSETS_CHART" })}
                    </span>
                  </NavLink>
                </li>
                <li
                  className={`menu-item ${getMenuItemActive(
                    "/statistical/dau"
                  )}`}
                  aria-haspopup="true"
                >
                  <NavLink className="menu-link" to="/statistical/dau">
                    <i className="menu-bullet menu-bullet-dot">
                      <span />
                    </i>
                    <span className="menu-text">DAU</span>
                  </NavLink>
                </li> */}
              </ul>
            </div>
          </li>
        )}
        {/* Gold management */}

        {/* Shop management */}
        {/*begin::1 Level*/}
        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_CHI_NHANH) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/shop",
              true
            )}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
          >
            <NavLink className="menu-link menu-toggle" to="/shop">
              <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl("/media/svg/icons/Code/Git3.svg")} />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.SHOP" })}
              </span>
            </NavLink>
            <div className="menu-submenu">
              <i className="menu-arrow" />
              <ul className="menu-subnav">
                <li className="menu-item menu-item-parent" aria-haspopup="true">
                  <span className="menu-link">
                    <span className="menu-text">
                      {intl.formatMessage({ id: "SIDEBAR.SHOP" })}
                    </span>
                  </span>
                </li>
                {listUserLoginPermission.includes(TYPE.QUAN_LY_CHI_NHANH) && (
                  <li
                    className={`menu-item ${getMenuItemActive("/shop/list")}`}
                    aria-haspopup="true"
                  >
                    <NavLink className="menu-link" to="/shop/list">
                      <i className="menu-bullet menu-bullet-dot">
                        <span />
                      </i>
                      <span className="menu-text">
                        {intl.formatMessage({ id: "SIDEBAR.SHOP" })}
                      </span>
                    </NavLink>
                  </li>
                )}
              </ul>
            </div>
          </li>
        )} */}
        {/*end::1 Level*/}

        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_MERCHANT) && (
          <li
            className={`menu-item menu-item-submenu ${getMenuItemActive(
              "/merchant",
              false
            )}`}
            aria-haspopup="true"
          >
            <NavLink className="menu-link menu-toggle" to="/merchant">
              <span className="svg-icon menu-icon">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Group.svg"
                  )}
                />
              </span>
              <span className="menu-text">
                {intl.formatMessage({ id: "SIDEBAR.MERCHANT" })}
              </span>
            </NavLink>
          </li>
        )} */}

        {/* Transaction management */}

        {/* Product management */}
        {/*begin::1 Level*/}

        {/* popup management */}

        {/* end */}

        {/* Admin management */}

        {/* User Guest management */}

        {/* popup management loan*/}

        {/* end */}

        {/* {listUserLoginPermission.includes(TYPE.QUAN_LY_TIEN) && <li
              className={`menu-item ${getMenuItemActive("/money-management", false)}`}
              aria-haspopup="true"
          >
            <NavLink className="menu-link" to="/money-management">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Money.svg")} />
            </span>
              <span className="menu-text">{intl.formatMessage({ id: 'SIDEBAR.USER_MONEY' })}</span>
            </NavLink>
          </li>} */}
      </ul>
    </>
  );
}
export default withRouter(injectIntl(AsideMenuList));
